<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card>
      <v-row class="pt-3 px-1" justify="start" align="top">
        <v-col cols="auto" style="max-width: 180px">
          <v-menu
            v-model="pagination.startMenu"
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                readonly
                v-model="pagination.startDate"
                label="Tanggal Awal"
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pagination.startDate"
              @input="onDateChange('start')"
              locale="id"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="auto" style="max-width: 180px">
          <v-menu
            v-model="pagination.endMenu"
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="pagination.endDate"
                label="Tanggal Akhir"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pagination.endDate"
              @input="onDateChange"
              locale="id"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="auto" style="max-width: 180px">
          <v-autocomplete
            item-text="status_name"
            item-value="status"
            :items="statusOptions"
            v-model="pagination.status"
            @change="updateQuery('status', $event)"
            label="Status"
            dense
            outlined
          ></v-autocomplete>
        </v-col>

        <v-col cols="auto" style="max-width: 180px">
          <v-autocomplete
            item-text="mst_site_name"
            item-value="mst_site_id"
            :items="siteOptions"
            v-model="pagination.siteId"
            @change="updateQuery('siteId', $event)"
            label="Lokasi Kerja"
            dense
            outlined
          ></v-autocomplete>
        </v-col>

        <v-col cols="auto" style="max-width: 180px">
          <v-autocomplete
            item-text="status_os"
            item-value="status_name"
            :items="statusOsOptions"
            v-model="pagination.statusOs"
            @change="updateQuery('statusOs', $event)"
            label="Status Karyawan"
            dense
            outlined
          ></v-autocomplete>
        </v-col>

        <v-col cols="auto" style="max-width: 180px">
          <v-autocomplete
            item-text="mst_division_name"
            item-value="mst_division_id"
            :items="divisionsOptions"
            v-model="pagination.divisionId"
            @change="updateQuery('divisionId', $event)"
            label="Department"
            dense
            outlined
          ></v-autocomplete>
        </v-col>

        <v-col cols="auto" style="max-width: 180px">
          <v-text-field
            v-model="pagination.search"
            label="Search"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            @input="debouncedSearch"
          ></v-text-field>
        </v-col>

        <v-col cols="auto">
          <v-btn color="primary" @click="exportToExcel">Download</v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
            mobile-breakpoint="0"
            dense
            class="elevation-5"
            :headers="tableHeaders"
            :items="suggestionsList"
            :items-per-page.sync="pagination.itemsPerPage"
            :page.sync="pagination.page"
            :sort-by="pagination.sortBy"
            :sort-desc="pagination.sortDesc"
            :loading="isLoading"
            :server-items-length="totalSuggestions"
            item-key="id"
            @update:page="updateQuery('page', $event)"
            @update:items-per-page="updateQuery('itemsPerPage', $event)"
            @update:sort-by="updateQuery('sortBy', $event)"
            @update:sort-desc="updateQuery('sortDesc', $event)"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>
                    {{ item.created_on }}
                  </td>
                  <td>
                    <div class="small-font">
                      {{ item.created_by_name }}
                    </div>
                    <div class="small-font">
                      {{ item.mst_employee_nik }}
                    </div>
                  </td>
                  <td>
                    {{ item.status_os }}
                  </td>
                  <td>
                    {{ item.mst_position_name }}
                  </td>
                  <td>
                    {{ item.mst_division_name }}
                  </td>
                  <td>
                    {{ item.mst_site_name }}
                  </td>
                  <td>
                    {{ item.atasan }}
                  </td>
                  <td>
                    {{ item.oei }}
                  </td>
                  <td>
                    {{ item.implementasi }}
                  </td>
                  <td>
                    <span
                      class="text-lightgray"
                      @click="openDialogSuggestionDetail(item)"
                    >
                      {{ item.title }}
                    </span>
                  </td>
                  <td>{{ item.suggestion_category_name }}</td>
                  <td>{{ item.last_status }}</td>
                  <td>{{ item.status_implementasi }}</td>
                  <td>{{ item.status_top }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <!-- suggestion detail -->
    <v-dialog v-model="isDialogOpenSuggestionDetail" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid">
            <v-autocomplete
              v-model="suggestions.suggestion_category_id"
              :items="suggestionCategoryOptions"
              item-text="name"
              item-value="id"
              label="Kategori"
              required
              readonly
              :loading="isSuggestionCategoryLoading"
              @update:search-input="fetchSuggestionCaretgory"
            />
            <v-text-field
              v-model="suggestions.title"
              label="Judul"
              readonly
              required
            ></v-text-field>
            <v-textarea
              v-model="suggestions.description"
              label="Latar Belakang / Uraian Masalah"
              required
              readonly
              autocomplete="new-description"
            ></v-textarea>
            <v-textarea
              v-model="suggestions.suggestions"
              label="Solusi"
              readonly
              required
            ></v-textarea>

            <v-text-field
              v-model="formattedBenefitDetail"
              label="Potensi Benefit"
              type="text"
              readonly
            >
            </v-text-field>

            <v-textarea
              v-model="suggestions.noted"
              label="Keterangan Biaya"
              readonly
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenSuggestionDetail = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import exceljs from "exceljs";
import { saveAs } from "file-saver";
import { getLast30Days, dateFormatDmy } from "@/utils/date";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      statusOptions: [
        { status: "all", status_name: "All" },
        { status: "Waiting Approval", status_name: "Waiting Approval" },
        { status: "Need To Analysis", status_name: "Need To Analysis" },
        { status: "Approved Atasan", status_name: "Approved Atasan" },
        {
          status: "Approved Operation Excellence & Improvement",
          status_name: "Approved Operation Excellence & Improvement",
        },
        { status: "implemented", status_name: "Implemented" },
        { status: "rejected", status_name: "Rejected" },
      ],
      statusOsOptions: [
        { status_os: "All", status_name: "all" },
        {
          status_os: "Outsourcing",
          status_name: "1",
        },
        {
          status_os: "Non Outsourcing",
          status_name: "0",
        },
      ],
      divisionsOptions: [],
      siteOptions: [],
      awsObjectUrl: process.env.VUE_APP_AWS_OBJECT_URL,
      awsPath: process.env.VUE_APP_AWS_PATH,
      tableHeaders: [
        { text: "Tanggal", align: "center", value: "id" },
        { text: "Nama", align: "center", value: "employee_name" },
        { text: "Status Karyawan", align: "center", value: "status_os" },
        { text: "Jabatan", align: "center", value: "jabatan" },
        { text: "Department", align: "center", value: "department" },
        { text: "Lokasi Kerja", align: "center", value: "mst_site_name" },
        { text: "Approver Atasan", align: "center", value: "atasan" },
        { text: "Approver OEI", align: "center", value: "oei" },
        {
          text: "Approver Implementasi",
          align: "center",
          value: "implementasi",
        },
        { text: "Judul", align: "center", value: "title" },
        { text: "Kategori", align: "center", value: "category" },
        { text: "Status Proses", align: "center", value: "last_status" },
        {
          text: "Status Implementasi",
          align: "center",
          value: "status_implementasi",
        },
        { text: "Status Top Idea", align: "center", value: "status_top_idea" },
        // {
        //   text: "Riwayat Persetujuan",

        //   align: "center",
        //   value: "history_approval",
        // },
        // {
        //   text: "Lampiran Perhitungan",

        //   align: "center",
        //   value: "history_approval",
        // },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        startMenu: false,
        endMenu: false,
        startDate: getLast30Days().start,
        endDate: getLast30Days().end,
        search: "",
        status: null,
        statusOs: null,
        siteId: null,
        divisionId: null,
      },
      totalSuggestions: 0,
      suggestionsList: [],
      isLoading: false,
      isDialogOpen: false,
      isDivisionsLoading: false,
      isDialogOpenSuggestionDetail: false,
      pathDocumentList: [],
      exportColumns: [
        { key: "created_on", label: "Tanggal" },
        { key: "created_by_name_and_nik", label: "Nama" },
        { key: "status_os", label: "Status Karyawan" },
        { key: "mst_position_name", label: "Jabatan" },
        { key: "mst_division_name", label: "Department" },
        { key: "mst_site_name", label: "Lokasi Kerja" },
        { key: "atasan", label: "Approver Atasan" },
        { key: "oei", label: "Approver OEI" },
        { key: "implementasi", label: "Approver Implementasi" },
        { key: "title", label: "Judul" },
        { key: "suggestion_category_name", label: "Kategori" },
        { key: "description", label: "Latar Belakang" },
        { key: "suggestions", label: "Solusi" },
        { key: "last_status", label: "Status" },
        { key: "status_implementasi", label: "Status Implementasi" },
        { key: "status_top", label: "Status Top Idea" },
      ],
      dialogTitle: "",
      suggestions: {
        comments: "",
        status: "",
      },
      suggestionCategoryOptions: null,
      suggestionDetailCategoryOptions: null,
      isSuggestionCategoryLoading: false,
      isFormValid: false,
    };
  },
  methods: {
    fetchDivisions() {
      this.isDivisionsLoading = true;
      api
        .get("/divisions")
        .then(({ data }) => {
          this.divisionsOptions = data.data.data;
          this.divisionsOptions.unshift({
            mst_division_id: "all",
            mst_division_name: "All",
          });

          this.pagination.divisionId = "all";
        })
        .catch((error) => {
          console.error("Error fetching division:", error);
        })
        .finally(() => {
          this.isLoading = false;
          this.isDivisionsLoading = false;
          store.dispatch("hideLoading");
        });
    },
    fetchSites() {
      api
        .get("/sites?corporateId=2")
        .then(({ data }) => {
          this.siteOptions = data.data.data;
          this.siteOptions.unshift({
            mst_site_id: "all",
            mst_site_name: "All",
          });
          this.pagination.siteId = "all";
        })
        .catch((error) => {
          console.error("Error fetching sites:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    fetchSuggestionCaretgory() {
      this.isSuggestionCategoryLoading = true;
      api
        .get("/suggestions-categories")
        .then(({ data }) => {
          this.suggestionCategoryOptions = data.data.data;
          this.suggestionDetailCategoryOptions = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching roles:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
          this.isSuggestionCategoryLoading = false;
        });
    },

    async fetchReportStatus() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        status: query.status || this.pagination.status || "all",
        statusOs: query.statusOs || this.pagination.statusOs || "all",
        siteId: query.siteId || this.pagination.siteId || "all",
        divisionId: query.divisionId || this.pagination.divisionId || "all",
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      await api
        .get("/report/status", { params })
        .then(({ data }) => {
          // console.log(data);
          this.suggestionsList = data.data.data;
          this.totalSuggestions = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    async exportToExcel() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: 1,
        limit: -1,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        status: query.status || this.pagination.status || "all",
        statusOs: query.statusOs || this.pagination.statusOs || "all",
        siteId: query.siteId || this.pagination.siteId || "all",
        startDate: query.startDate || this.pagination.startDate,
        endDate: query.endDate || this.pagination.endDate,
      };

      await api
        .get("/report/status", { params })
        .then(({ data }) => {
          const dataExcel = data.data.data;

          // Buat workbook dan worksheet
          const workbook = new exceljs.Workbook();
          const worksheet = workbook.addWorksheet("Data Export");

          // Tambahkan header ke worksheet
          const headerRow = this.exportColumns.map((col) => col.label);
          worksheet.addRow(headerRow);

          // Tambahkan data ke worksheet
          dataExcel.forEach((item) => {
            worksheet.addRow(this.exportColumns.map((col) => item[col.key]));
          });

          // Styling header (Bold + Background Color + Center)
          worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFF00" }, // Kuning
            };
          });

          // Styling semua sel agar center
          worksheet.eachRow((row) => {
            row.eachCell((cell) => {
              cell.alignment = { horizontal: "center", vertical: "middle" };
            });
          });

          // Auto width untuk setiap kolom
          worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
              maxLength = Math.max(
                maxLength,
                cell.value ? cell.value.toString().length : 10
              );
            });
            column.width = maxLength + 2; // Tambahkan padding
          });

          // Simpan file Excel
          workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(
              blob,
              `Report_status_(${dateFormatDmy(
                this.pagination.startDate
              )}_sampai_${dateFormatDmy(this.pagination.endDate)}).xlsx`
            );
          });
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },

    openDialogSuggestionDetail(params = null) {
      this.dialogTitle = "Detail Suggestion";
      this.suggestions = { ...params };
      this.isSuggestionCategoryLoading = false;
      this.selectedSuggestionCategoryId = params.suggestion_category_id;
      this.isDialogOpenSuggestionDetail = true;
      this.suggestionId = params.suggestion_id;
      this.submitRead();
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
      this.pagination.status = query.status || "all";
      this.pagination.statusOs = query.statusOs || "all";
      this.pagination.siteId = parseInt(query.siteId) || "all";
      this.pagination.divisionId = parseInt(query.divisionId) || "all";
    },
    updateQuery(key, value) {
      // console.log(key);
      // console.log(value);
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
    getToday() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // Bulan mulai dari 0
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`; // Format ISO
    },
    onDateChange(param) {
      if (param === "start") {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      } else {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }
    },
  },
  watch: {
    pagination: {
      handler: "fetchReportStatus",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  mounted() {
    store.commit("setTitle", "Status");
    this.fetchSites();
    this.fetchDivisions();
    this.fetchReportStatus();
    this.fetchSuggestionCaretgory();
    this.updatePagination(this.$route.query);
  },

  computed: {
    formattedBenefitDetail: {
      get() {
        return new Intl.NumberFormat("id-ID").format(this.suggestions.benefit);
      },
      set(value) {
        // Hapus titik saat input berubah, agar tetap bisa menyimpan angka asli
        this.suggestions.benefit = parseInt(value.replace(/\./g, "")) || 0;
      },
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(5),
td:nth-child(6),
td:nth-child(7) {
  text-align: center;
}

.text-lightgray {
  background-color: #ffffff; /* abu-abu terang */
  cursor: pointer;
  padding: 5px;
}
</style>
